import styled from 'styled-components';

export const Base = styled.div`
	// layout
	height: 28px;
	margin: 8px;
	margin-top: 9px;
	margin-bottom: 7px;
	display: flex;
	padding: 4px;

	// style
	background: transparent;
	border: 0px solid transparent;
	border-radius: 4px;
	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const InnerWrapper = styled.div`
	display: flex;
	padding-left: 3px;
`;

export const ZoomWrapper = styled.div`
	margin-top: 3px;
	height: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const DownArrow = styled.div`
	width: 12px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${({ theme }) => theme.gray[100]};
`;

export const ZoomAmount = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[1000]};
	text-align: right;
	padding-right: 4px;
	padding-bottom: 2px;
`;
